var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfitGenerated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4.55228 3 5 3.44772 5 4V17C5 18.1046 5.89543 19 7 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H7C4.79086 21 3 19.2091 3 17V4C3 3.44772 3.44772 3 4 3Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0058 5V7H17.5649L14.7862 9.78101C14.6963 9.87201 14.4155 10 14.2866 10H12.7259C12.0675 10 11.2551 10.315 10.7895 10.781L7.29263 14.281C6.90246 14.672 6.90246 15.328 7.29263 15.719C7.48777 15.914 7.75515 16 8.01084 16C8.26652 16 8.5339 15.914 8.72904 15.719L12.2263 12.219C12.3162 12.128 12.597 12 12.7259 12H14.2866C14.945 12 15.7574 11.685 16.223 11.219L19.0017 8.43799V12H21V6C21 5.448 20.5524 5 20.0008 5H14.0058Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitGenerated);
export default __webpack_public_path__ + "static/media/profitGenerated.a293881f73e539a497c710387365aaef.svg";
export { ForwardRef as ReactComponent };